export default "__VITE_ASSET__BfBH8Tm1__"